
import { computed } from '@nuxtjs/composition-api';
import { useQuery } from '@vue/apollo-composable';

import type { StaffCategoriesQuery, StaffCategoriesQueryVariables } from '@/graphql/generated';
import { staffCategoriesQuery } from '@/graphql/queries/staffCategoriesQuery';

export type StaffCategory = StaffCategoriesQuery['scenkonstStaffCategories'][0]
export const useStaffCategories = () => {
  const { result, loading } = useQuery<StaffCategoriesQuery, StaffCategoriesQueryVariables>(staffCategoriesQuery);

  return {
    staffCategories: computed(() => result.value?.scenkonstStaffCategories || []),
    staffCategoriesLoading: loading,
  };
};
